import { render, staticRenderFns } from "./OrderBoxNew.vue?vue&type=template&id=09e4ad2d&scoped=true"
import script from "./OrderBoxNew.vue?vue&type=script&lang=js"
export * from "./OrderBoxNew.vue?vue&type=script&lang=js"
import style0 from "./OrderBoxNew.vue?vue&type=style&index=0&id=09e4ad2d&prod&lang=scss&scoped=true"
import style1 from "./OrderBoxNew.vue?vue&type=style&index=1&id=09e4ad2d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09e4ad2d",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrderBoxTabTitle: require('/drone/src/components/OrderBox/OrderBoxTabTitle.vue').default,WxFollowQr: require('/drone/src/components/WxFollowQr.vue').default,PZTabs: require('/drone/src/components/PZTabs/index.vue').default,OrderBoxStatus: require('/drone/src/components/OrderBox/OrderBoxStatus.vue').default,PzImage: require('/drone/src/components/PzImage/index.vue').default,PZButton: require('/drone/src/components/PZButton/index.vue').default,Empty: require('/drone/src/components/Empty/index.vue').default,GoodsListPage: require('/drone/src/components/GoodsListPage/index.vue').default})
